import React, { useEffect, useState } from "react";
import Menus from "../Menus";
import Footers from "../Footers";
import { format } from "date-fns";
import MenuTop from "../MenuTop";
import DataTable from 'react-data-table-component';
import { API_ROUTES } from "../../../utils/constants";
import Nulls from "../Nulls";
import { useForm } from "react-hook-form";
import Loader from "./Loaders/Loader";



const UserWallets = (props) => {
    const { capitalizeWords, objectToFormData, isAuthExpired, token, downloadLargeData, newNotify, getNotifyCounts, isOffcanvasActive, handleMenuToggle, notifications, fetchNotifys, isAdmins } = props;
    const [isFade, setIsFade] = useState(true)

    useEffect(() => {document.title = "User Wallets | Daniezo"}, []);

    const {register, handleSubmit, formState: {errors, isValid, isSubmitting}} = useForm({
        mode: "onChange"
    });

    const [isLoading, setIsLoading] = useState(true);
    const [datas, setDatas] = useState([]);
    const [dataTotal, setDataTotal] = useState(0);
    const [userWallet, setUserWallet] = useState(0);
    const [page, setPage] = useState(1);
    const countPerPage = 50;
    const [searchText, setSearchText] = useState('');
    const [isDivVisible, setDivVisibility] = useState(false);
    const [showSecDownload, setShowSecDownload] = useState(false);


    const columns = [
        {
            name: 'Customer',
            // selector: row => row.userDetails?.firstname ? <span>{`${row.userDetails?.firstname} ${row.userDetails?.lastname}`}</span> : row.userDetails?.email,
            selector: row => row.userDetails?.firstname !== null ? <div>{`${row.userDetails?.firstname} ${row.userDetails?.lastname}`}<div style={{ fontSize:'15px', marginTop:'4px', color:'#069' }}>({row.userDetails?.phone})</div></div> : row.userDetails?.email,
            sortable: true,
        },
        {
          name: 'Balance',
          selector: row => row.balance ? <b>₦{parseFloat(row.balance).toLocaleString()}</b> : <b>{`0.00`}</b>,
        },
        {
            name: 'Codes',
            selector: row => row.codes,
        },
        {
            name: 'Date Created',
            selector: row => row.created_at ? format(new Date(row.created_at), 'MMM d, yyyy h:mma') : <Nulls />,
            sortable: true,
        },
        {
            name: 'Date Updated',
            selector: row => row.updated_at ? format(new Date(row.updated_at), 'MMM d, yyyy h:mma') : <Nulls />,
        },
    ];

    
    const getDatas = async (isLoad=true, status="", filters="") => {
        const dataString = { 
            page: page,
            perPage: countPerPage,
            status: status,
            filters: filters,
        };
        setIsFade(true);
        try {
            const response = await fetch(API_ROUTES.WALLETS, {
                method: "POST",
                body: objectToFormData(dataString),
                headers: {'hashKey': token}
            });
            const responseJSON = await response.json();
            isAuthExpired(responseJSON); // check for expired login
            
            if (responseJSON.status.toString() === "200") {
                const responseData = responseJSON.data.data;
                const totalData = responseData.length;
                setDataTotal(totalData);
                setUserWallet(responseJSON.data.total_wallets);
                setDatas(responseData);
                setIsFade(false);
                setIsLoading(false);
                return;
            }
            setIsFade(false);
            setIsLoading(false);
            setDatas([]);
        } catch (error) {
            console.log('Error getting data: ', error);
            setDatas([]);
            setIsLoading(false);
            setIsFade(false);
        }
    }
    
    useEffect(() => {
        getDatas();
        getNotifyCounts();
        fetchNotifys();
    }, [page, countPerPage, searchText]);


    const handleChange = async (event) => {
        const filters = event.target.value;
        getDatas(true, "", filters);
    }


    const fetchDatas = async (apiData) => {
        downloadLargeData(apiData, "wallets", "-wallets-data");
    }

    const handleButtonClick = () => {
        setDivVisibility(!isDivVisible);
        setShowSecDownload(true);
    }
    const handleButtonClose = (e) => {
        e.preventDefault();
        setDivVisibility(!isDivVisible);
        setShowSecDownload(false);
    }

    


    return (
        <>
            <div className="container-scroller">
                <MenuTop isAdmins={isAdmins} notifications={notifications} newNotify={newNotify} isOffcanvasActive={isOffcanvasActive} handleMenuToggle={handleMenuToggle} />
                
                <div className="container-fluid page-body-wrapper">
                    <Menus isAdmins={isAdmins} notifications={notifications} newNotify={newNotify} isOffcanvasActive={isOffcanvasActive} handleMenuToggle={handleMenuToggle} />

                    <div className="main-panel">
                        <div className="content-wrapper p-xs-0">
                            <div className="row grid-margin mt--10 mt-xs-0">
                                <div className="col-sm-12 mb-xs-40">
                                    <div className="col-12">
                                        <h2 className="mt-20 mt-xs-30 mb--20 mb-xs-0">User Wallets</h2>
                                    </div>

                                    <div className="offset-lg-8 col-lg-4 offset-sm-7 col-sm-5 mb-20 mt-xs-20 mb-xs-20">
                                        <div className="row">
                                            <div className="col-12">
                                                <input type="text" placeholder="Search by name..."
                                                    className="filter_text"
                                                    onChange={handleChange}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="mt--15 pb-10" style={{ position:'relative', zIndex:'99' }}>
                                        <form onSubmit={handleSubmit(fetchDatas)}>
                                            <div className={`row sliding-div ${isDivVisible ? 'visible' : ''}`}>
                                                <div className="col-2 text-right pr-5">
                                                    <button className="close_btns" onClick={(e) => handleButtonClose(e)}>x</button>
                                                </div>
                                                <div className="col-5 pl-0 pr-0">
                                                    <input type="date" {...register("dateFrom")} />
                                                </div>
                                                <div className="col-5 pl-0">
                                                    <input type="date" {...register("dateTo")} />
                                                </div>
                                            </div>

                                            {
                                                !showSecDownload &&
                                                <button onClick={handleButtonClick} className="showDateBtn"><i className="fa fa-print"></i> <font className="d-none d-sm-inline-block">Download</font> </button>
                                            }
                                            {
                                                showSecDownload &&
                                                <button type="submit" 
                                                disabled={isSubmitting || !isValid} 
                                                style={{ opacity: (isSubmitting || !isValid) ? '0.5' : 1 }}
                                                className="showDateBtn"
                                                ><i className="fa fa-print"></i> <font className="d-none d-sm-inline-block">{(isSubmitting && !isValid) ? "Downloading" : "Download"}</font> </button>
                                            }
                                        </form>
                                    </div>

                                    <div className="offset-xl-0 col-xl-12 mt--10 mt-xs-40 mb--20 mb-xs--30 pl-0 pl-xs-10">
                                        <div className="row">
                                            <div className="col-sm-3 col-9 pr-10 pl-xs-15 pr-xs-10 mb-xs-10">
                                                <div className="card bg-primary-light card-shadow-primary">
                                                    <div className="card-body p-20">
                                                        <div className="stats1">
                                                            <h6 className="">Total User Wallet</h6>
                                                            <h3 className="mb-0 blue">&#8358;{parseFloat(userWallet).toLocaleString()}</h3>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {
                                        isLoading ? <Loader /> 
                                    :

                                        <DataTable
                                            className={`mt-30 pt-10 table_css ${isFade && 'opaqs'}`}
                                            columns={columns}
                                            data={datas}
                                            highlightOnHover
                                            pagination
                                            paginationServer
                                            paginationTotalRows={dataTotal}
                                            paginationPerPage={countPerPage}
                                            paginationComponentOptions={{
                                                noRowsPerPage: true,
                                            }}
                                            onChangePage={(newPage) => setPage(newPage)}
                                        />
                                    }
                                </div>
                            </div>
                        </div>
                        
                        <Footers />
                    </div>
                </div>
            </div>
        </>
    );
}

export default UserWallets;